import React, { Component } from "react";
import { BoxSuccess, MnemoLoading, MSection } from "components/misc";
import { LABEL_UNIVERSITY, ROUTES } from "const";
import { courseService, networkErrorHelper } from "libs";
import { Helmet } from "react-helmet";
import { withRouter } from "react-router-dom";
import {
    Row, Col,
    Button,
    AccordionHeader,
    AccordionBody,
    Container
} from "design-react-kit";
import { MSearch } from "components/forms";

class CourseBrowser3036CFU extends Component {

    _class1Ref = null;

    state = {

        loading: true,
        loadingError: false,
        currentRegion: '',
        currentCompetitionClass: '',

        courseCompetitionClass: [],
        courseFiltered: [],

        payloadCompetitionClass: [],
        payloadRegion: [],

        filterRegionOpen: false,
        filterRegionApplied: false,

        filterCCOpen: false,
        filterCCApplied: false,

        toggleCourse60: false,
        toggleCourse30All2: false,
        toggleCourse36All4: false,
        toggleCourse60All5: false,

        currentAA: '2025'
    }

    componentDidMount() {

        this.setState({ loading: true, loadingError: false });
        const { company } = this.props.match.params;

        // if company is not empty and is not in LABEL_UNIVERSITY, then go to 404 page
        if (company && !LABEL_UNIVERSITY[company]) {
            this.props.history.push(ROUTES.PAGE_404);
        }

        this.loadCompetionClasses(company);
        this._class1Ref = React.createRef();
    }

    loadCompetionClasses(company) {

        courseService
            .listAdminByCompetitionClass('ABILITAZIONI60CFU_BANDO', this.state.currentAA, company)
            .then(({ data }) => {

                const { courseCompetitionClass } = data.payload;

                const payloadCompetitionClass = [];
                const payloadRegion = [];

                // fill the payload for the search component
                courseCompetitionClass.forEach((item) => {

                    const foundCC = payloadCompetitionClass.find(el => el.value === item.competitionClass);
                    if (!foundCC) {
                        payloadCompetitionClass.push({ value: item.competitionClass, label: item.competitionClass + ' - ' + item.note });
                    }

                    const foundRegion = payloadRegion.find(el => el.value === item.region);
                    if (!foundRegion) {
                        payloadRegion.push({ value: item.region, label: item.region.toUpperCase() });
                    }

                    // order paylodRegion based on value
                    payloadRegion.sort((a, b) => {
                        if (a.value < b.value) return -1;
                        if (a.value > b.value) return 1;
                        return 0;
                    });

                    // order paylodCompetitionClass based on value
                    payloadCompetitionClass.sort((a, b) => {
                        if (a.value < b.value) return -1;
                        if (a.value > b.value) return 1;
                        return 0;
                    });
                });

                this.setState({
                    courseCompetitionClass,
                    courseFiltered: courseCompetitionClass,
                    payloadCompetitionClass, payloadRegion,
                    loading: false
                });

            })
            .catch(error => {
                console.log(error);
                this.setState({ loading: false });
                if (!networkErrorHelper.is404(error)) {
                    networkErrorHelper.notify(error);
                    this.setState({ loadingError: true });
                }
            });

    }

    toggleCourse = id => {

        this.setState({
            ...this.defaultState,
            [`toggleCourse${id}`]: !this.state[`toggleCourse${id}`],
        });

    }

    toggleFilter = id => {

        this.setState({ filterRegionApplied: false, filterCCApplied: false });

        switch (id) {

            case 'filterRegionOpen':
                this.setState({ filterCCOpen: false, filterRegionOpen: true });
                this.applyFilter('', '');
                break;

            case 'filterCCOpen':
                this.setState({ filterCCOpen: true, filterRegionOpen: false });
                this.applyFilter('', '');
                break;
            default:
        };
    }

    openCourse(code) {
        window.open(`${ROUTES.COURSE_LANDINGPAGE}\\${code}`, '_blank');
    }

    changeCompetitionClass = (_, value) => {

        const newCompetitionClass = (value) ? value.value : '';
        this.applyFilter(newCompetitionClass, '');

        this.setState({ filterCCApplied: true });
    }

    changeRegion = (_, value) => {

        const newRegion = (value) ? value.value : '';
        this.applyFilter('', newRegion);
        this.setState({ filterRegionApplied: true });
    }

    filterReset() {

        this.applyFilter('', '');
        this.setState({ filterRegionOpen: false, filterCCOpen: false, filterRegionApplied: false, filterCCApplied: false });
        if (this._class1Ref && this._class1Ref.current) {
            this._class1Ref.current.clearValue();
        }
    }

    applyFilter(competitionClass, region) {

        const { courseCompetitionClass } = this.state;
        let courseFiltered = courseCompetitionClass;

        if (competitionClass) {
            courseFiltered = courseFiltered.filter(course => course.competitionClass === competitionClass);
        }

        if (region) {
            courseFiltered = courseFiltered.filter(course => course.region === region);
        }

        this.setState({
            currentCompetitionClass: competitionClass,
            currentRegion: region,
            courseFiltered,
        });

        return courseFiltered;
    }

    renderFilterSection() {

        const {
            payloadCompetitionClass, payloadRegion,
            filterRegionOpen, filterCCOpen
        } = this.state;

        return (
            <>
                <MSection className="mb-3">
                    <Row>
                        <Col size="12" md="6">
                            <AccordionHeader active={filterCCOpen} onToggle={() => this.toggleFilter('filterCCOpen')}>
                                <h6>Ricerca per Classe di Concorso</h6>
                            </AccordionHeader>
                            <AccordionBody active={filterCCOpen}>
                                <MSearch
                                    key="class-select"
                                    field="class-select"
                                    id="class-select"
                                    name="class-select"
                                    placeHolder="Inserisci o seleziona classe"
                                    payload={payloadCompetitionClass}
                                    onChange={this.changeCompetitionClass}
                                    ref={this._class1Ref}
                                />
                                <Button outline className="float-right mt-2"
                                    onClick={e => this.filterReset()}
                                >Cancella filtri</Button>
                            </AccordionBody>
                        </Col>
                        <Col size="12" md="6">
                            <AccordionHeader active={filterRegionOpen} onToggle={() => this.toggleFilter('filterRegionOpen')}>
                                <h6>Ricerca per Regione</h6>
                            </AccordionHeader>
                            <AccordionBody active={filterRegionOpen}>
                                <MSearch
                                    key="region2-select"
                                    field="region2-select"
                                    id="region2-select"
                                    name="region2-select"
                                    placeHolder="Inserisci o seleziona regione"
                                    payload={payloadRegion}
                                    onChange={this.changeRegion}
                                />
                                <Button outline className="float-right mt-2"
                                    onClick={e => this.filterReset()}
                                >Cancella filtri</Button>
                            </AccordionBody>
                        </Col>
                    </Row>
                </MSection>
            </>);
    }

    getCourseCodes(course) {

        let c30all2 = course.code;
        let c30all4 = course.code;
        let c36all5 = course.code;

        // Prefix based on company
        let prefix = '';
        switch (course.instituteCompany) {
            case 'iul':
                prefix = 'IUL';
                break;
            case 'unicamillus':
                prefix = 'UM';
                break;
            case 'reggio':
                prefix = 'RC';
                break;
            case 'unitelma':
                prefix = 'UNT';
                break;
            default:
                prefix = '';
        }

        c30all2 = prefix + "ALL230CFU" + course.competitionClass + "_VC_25";
        c30all4 = prefix + "ALL430CFU" + course.competitionClass + "_VC_25";
        c36all5 = prefix + "ALL536CFU" + course.competitionClass + "_VC_25";
        return { c30all2, c30all4, c36all5 };
    }

    renderCourseList() {

        const { courseFiltered, filterCCOpen, filterRegionOpen, filterRegionApplied, filterCCApplied } = this.state;
        let toShow = (courseFiltered && courseFiltered.length > 0) ? true : false;

        // const showCompany = (company) ? true : false;
        let courseList = [];

        if (courseFiltered.length === 0) {
            return <BoxSuccess>La ricerca non ho prodotto alcun risultato.</BoxSuccess>;
        }

        if (filterCCOpen && filterCCApplied) {

            let currentList = [];
            let currentRegion = courseFiltered[0].region;
            let currentTitle = courseFiltered[0].competitionClass + ' - ' + courseFiltered[0].note;

            courseFiltered.forEach((course, i) => {
                if (currentRegion !== course.region) {

                    if (currentList.length > 0) {
                        courseList.push(
                            <div key={`listdiv-${i}`}>
                                <h6 className="text-green">{currentRegion.toUpperCase()} - {currentTitle}</h6>
                                <ul>{currentList}</ul>
                            </div>);
                    }
                    currentRegion = course.region;
                    currentList = [];

                }

                const { c30all2, c30all4, c36all5 } = this.getCourseCodes(course);

                if (course.instituteCompany === 'unicamillus') {
                    currentList.push(
                        <li key={`list-${i}`} >
                            {LABEL_UNIVERSITY[course.instituteCompany]}  -
                            <a href={`${ROUTES.COURSE_LANDINGPAGE_FULL}/${c30all2}`} target="_blank" rel="noopener noreferrer" className="text-green" >
                                <b> Iscrizione 30 ALL 2</b>
                            </a> -
                            <a href={`${ROUTES.COURSE_LANDINGPAGE_FULL}/${c30all4}`} target="_blank" rel="noopener noreferrer" className="text-green" >
                                <b> Iscrizione 30 ALL 4</b>
                            </a> -
                            <a href={`${ROUTES.COURSE_LANDINGPAGE_FULL}/${c36all5}`} target="_blank" rel="noopener noreferrer" className="text-green" >
                                <b> Iscrizione 36 ALL 5</b>
                            </a>
                        </li>);
                } else {
                    currentList.push(
                        <li key={`list-${i}`} >
                            {LABEL_UNIVERSITY[course.instituteCompany]}  -
                            <a href={`${ROUTES.COURSE_LANDINGPAGE_FULL}/${c30all2}`} target="_blank" rel="noopener noreferrer" className="text-green" >
                                <b> Iscrizione 30 ALL 2</b>
                            </a> -
                            <a href={`${ROUTES.COURSE_LANDINGPAGE_FULL}/${c30all4}`} target="_blank" rel="noopener noreferrer" className="text-green" >
                                <b> Iscrizione 30 ALL 4</b>
                            </a>
                        </li>);
                }
            });

            if (currentList.length > 0) {

                const course = courseFiltered[courseFiltered.length - 1];
                courseList.push(
                    <div>
                        <h6 className="text-green">{currentRegion.toUpperCase()} - {course.note}</h6>
                        <ul>{currentList}</ul>
                    </div>
                );
            }
        } else if (filterRegionOpen && filterRegionApplied) {

            let currentList = [];
            let currentCC = courseFiltered[0].competitionClass;
            let currentTitle = courseFiltered[0].competitionClass + ' - ' + courseFiltered[0].note;

            courseFiltered.forEach((course, i) => {

                if (currentCC !== course.competitionClass) {

                    if (currentList.length > 0) {
                        courseList.push(
                            <div key={`listdiv-${i}`}>
                                <h6 className="text-green"> {currentTitle}</h6>
                                <ul>{currentList}</ul>
                            </div>);
                    }
                    currentCC = course.competitionClass;
                    currentTitle = course.competitionClass + ' - ' + course.note;
                    currentList = [];
                }

                const { c30all2, c30all4, c36all5 } = this.getCourseCodes(course);

                if (course.instituteCompany === 'unicamillus') {
                    currentList.push(
                        <li key={`list-${i}`} >
                            {course.region.toUpperCase()} - {LABEL_UNIVERSITY[course.instituteCompany]}  -
                            <a href={`${ROUTES.COURSE_LANDINGPAGE_FULL}/${c30all2}`} target="_blank" rel="noopener noreferrer" className="text-green" >
                                <b> Iscrizione 30 ALL 2</b>
                            </a> -
                            <a href={`${ROUTES.COURSE_LANDINGPAGE_FULL}/${c30all4}`} target="_blank" rel="noopener noreferrer" className="text-green" >
                                <b> Iscrizione 30 ALL 4</b>
                            </a> -
                            <a href={`${ROUTES.COURSE_LANDINGPAGE_FULL}/${c36all5}`} target="_blank" rel="noopener noreferrer" className="text-green" >
                                <b> Iscrizione 36 ALL 5</b>
                            </a>
                        </li>);
                } else {
                    currentList.push(
                        <li key={`list-${i}`} >
                            {course.region.toUpperCase()} - {LABEL_UNIVERSITY[course.instituteCompany]}  -
                            <a href={`${ROUTES.COURSE_LANDINGPAGE_FULL}/${c30all2}`} target="_blank" rel="noopener noreferrer" className="text-green" >
                                <b> Iscrizione 30 ALL 2</b>
                            </a> -
                            <a href={`${ROUTES.COURSE_LANDINGPAGE_FULL}/${c30all4}`} target="_blank" rel="noopener noreferrer" className="text-green" >
                                <b> Iscrizione 30 ALL 4</b>
                            </a>
                        </li>);
                }
            });

            if (currentList.length > 0) {

                const currentTitle = courseFiltered[courseFiltered.length - 1].competitionClass + ' - ' + courseFiltered[courseFiltered.length - 1].note;
                courseList.push(
                    <>
                        <h6 className="text-green"> {currentTitle}</h6>
                        <ul>{currentList}</ul>
                    </>);
            }
        } else {

            let currentList = [];
            let currentCC = courseFiltered[0].competitionClass;
            let currentTitle = currentCC + ' - ' + courseFiltered[0].note;

            courseFiltered.forEach((course, i) => {

                if (currentCC !== course.competitionClass) {

                    if (currentList.length > 0) {
                        courseList.push(
                            <>
                                <h6 className="text-green"> {currentTitle}</h6>
                                <ul>{currentList}</ul>
                            </>);
                    }
                    currentCC = course.competitionClass;
                    currentTitle = course.competitionClass + ' - ' + course.note;
                    currentList = [];
                }

                const { c30all2, c30all4, c36all5 } = this.getCourseCodes(course);

                // PINA teams il 30.12.2025 ore 13.10: Nino mi ha appena detto che i 36 CFU vincitori di concorso li vuole attivare solo con Unicamillus

                if (course.instituteCompany === 'unicamillus') {
                    currentList.push(
                        <li key={`list-${i}`}>
                            {course.region.toUpperCase()} - {LABEL_UNIVERSITY[course.instituteCompany]}
                            <a href={`${ROUTES.COURSE_LANDINGPAGE_FULL}/${c30all2}`} target="_blank" rel="noopener noreferrer" className="text-green" >
                                <b> Iscrizione 30 ALL 2</b>
                            </a> -
                            <a href={`${ROUTES.COURSE_LANDINGPAGE_FULL}/${c30all4}`} target="_blank" rel="noopener noreferrer" className="text-green" >
                                <b> Iscrizione 30 ALL 4</b>
                            </a> -
                            <a href={`${ROUTES.COURSE_LANDINGPAGE_FULL}/${c36all5}`} target="_blank" rel="noopener noreferrer" className="text-green" >
                                <b> Iscrizione 36 ALL 5</b>
                            </a>
                        </li>);
                } else {
                    currentList.push(
                        <li key={`list-${i}`}>
                            {course.region.toUpperCase()} - {LABEL_UNIVERSITY[course.instituteCompany]}
                            <a href={`${ROUTES.COURSE_LANDINGPAGE_FULL}/${c30all2}`} target="_blank" rel="noopener noreferrer" className="text-green" >
                                <b> Iscrizione 30 ALL 2</b>
                            </a> -
                            <a href={`${ROUTES.COURSE_LANDINGPAGE_FULL}/${c30all4}`} target="_blank" rel="noopener noreferrer" className="text-green" >
                                <b> Iscrizione 30 ALL 4</b>
                            </a>
                        </li>);
                }

            });

            if (currentList.length > 0) {

                const currentTitle = courseFiltered[courseFiltered.length - 1].competitionClass + ' - ' + courseFiltered[courseFiltered.length - 1].note;
                courseList.push(
                    <>
                        <h6 className="text-green"> {currentTitle}</h6>
                        <ul>{currentList}</ul>
                    </>
                );
            }
        }

        return (
            <>
                {(toShow)
                    ?
                    <>{courseList}</>
                    : <BoxSuccess>La ricerca non ho prodotto alcun risultato. Cambia i filtri di ricerca.</BoxSuccess>
                }
            </>
        );
    }

    render() {

        const title = "Percorsi Abilitanti SOLO per i Vincitori di Concorso 30-30-36 CFU D.P.C.M. 4 AGOSTO 2023 a.a. 2024/2025";


        const { loading, loadingError, toggleCourse30All2, toggleCourse30All4, toggleCourse36All5 } = this.state;
        let courseListSection = '';
        let filterSection = '';

        if (!loading && !loadingError) {
            courseListSection = this.renderCourseList();
            filterSection = this.renderFilterSection();
        }

        return (
            <section className="my-4">
                <Helmet>
                    <title>{title}</title>
                    <meta property="og:title" content={title} />
                </Helmet>
                <div>
                    <h1>{title}</h1>
                    <p>Per l'a.a. 2025/2026 il Ministero con i Decreti Ministeriali n. 148 del 24 Febbraio 2025, n. 156 del 24 Febbraio 2025
                        e il n. 270 del 19 Marzo 2025 ha autorizzato le Università all'attivazione dei Percorsi universitari di formazione iniziale
                        dei docenti delle scuole secondarie di primo e secondo grado.</p>
                    <p>Percorsi attivati SOLO per i vincitori di concorso:</p>
                    <AccordionHeader active={toggleCourse30All2} onToggle={() => this.toggleCourse('30All2')}>
                        <h6>Percorso 30 CFU/CFA Allegato 2: destinato ai vincitori del concorso che abbiano tre anni di servizio</h6>
                    </AccordionHeader>
                    <AccordionBody active={toggleCourse30All2}>
                        <p><b>Percorso preordinato all'acquisizione dei 30 CFU/CFA </b>
                            ai sensi dell'articolo 13, comma 2, del decreto legislativo 13 aprile 2017 n. 59
                            (ALL. 2 DPCM 4 agosto 2023): destinato ai vincitori del concorso che abbiano tre anni di servizio.</p>
                    </AccordionBody>
                    <AccordionHeader active={toggleCourse30All4} onToggle={() => this.toggleCourse('30All4')}>
                        <h6>Percorso 30 CFU/CFA Allegato 4: destinato ai vincitori del concorso a cui hanno avuto accesso con il requisito
                            dei 30 CFU/CFA non abilitanti, propedeutici al concorso.</h6>
                    </AccordionHeader>
                    <AccordionBody active={toggleCourse30All4}>
                        <p><b>Percorso preordinato all'acquisizione dei 30 CFU/CFA </b>
                            di completamento, di cui all'articolo 18 bis comma 3, secondo periodo, del decreto legislativo 13
                            aprile 2017 n. 59, destinato ai vincitori del concorso di cui al comma 1 dello stesso articolo (ALL.4 DPCM 4 agosto 2023).</p>
                    </AccordionBody>
                    <AccordionHeader active={toggleCourse36All5} onToggle={() => this.toggleCourse('36All5')}>
                        <h6>Percorso 36 CFU/CFA Allegato 5: destinato ai vincitori del concorso a cui hanno avuto
                            accesso con il requisito dei 24 CFU/CFA conseguiti entro il 31 ottobre 2022</h6>
                    </AccordionHeader>
                    <AccordionBody active={toggleCourse36All5}>
                        <p><b>Percorso preordinato all'acquisizione dei 36 CFU/CFA </b>
                            di completamento, di cui all'articolo 18 bis, comma 4, secondo periodo, del decreto legislativo 13 aprile 2017 n. 59
                            (ALL. 5 DPCM 4 agosto 2023): destinato a coloro i quali, entro il 31 ottobre 2022, abbiano conseguito i 24 CFU/CFA.</p>
                    </AccordionBody>
                </div>
                <hr />
                {(loading) ? <MnemoLoading /> : (<>
                    <Container>
                        {filterSection}
                        <MSection className="mb-3">
                            <Row>
                                <Col size="12">
                                    {courseListSection}
                                </Col>
                            </Row>
                        </MSection>
                    </Container>
                </>)}
                <hr />
                <h2>Attività Formativa</h2>
                <p><b>Lezioni</b>: in presenza nella regione di attivazione del corso presso la sede accreditata e on-line in
                    modalità telematica sincrona, ad eccezione dei tirocini e dei laboratori, con una percentuale massima del 50% del totale.</p>
                <p><b>Prova finale (prova scritta + lezione simulata):</b> nella sede Regionale dove è attivo il corso.</p>
                <p>Ammissione alla prova finale: è necessaria una percentuale minima di presenza alle attività formative pari al 70% per ogni attività formativa. </p>
                <p><b>Sedi Esami finali: </b>in una o più sedi della Regione dove è stato accreditato il corso </p>
                <p><b>Calendario lezioni: </b>a breve disponibile</p>
                <hr />
                <h2>Costi (*)</h2>
                <p>Il Costo dei Corsi è di € 1.900 + 16 (marca da bollo) rateizzabili in n. 3\4 versamenti.</p>
                <p>(*) Come previsto dal DPCM 4 Agosto 2023 per accedere alla prova finale é previsto un versamento di € 150 (Centocinquanta/00).</p>
                <p>E-mail: <a href="mailto:abilitazione@formazionedocenti.it">abilitazione@formazionedocenti.it</a></p>
            </section>

        );
    }
}

export default withRouter(CourseBrowser3036CFU);